import { Button } from '@design-system';
import { useAnalyticsEmitter } from '@utils/analytics/emitter';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { pathFor } from '../../helpers/links';
import { useFlow } from '../../providers/FlowProvider';
import { Image } from '../Image/Image';

export const EnquirySuccess = ({ productTitle }: { productTitle: string }) => {
  const { closeFlow } = useFlow();
  const { t } = useTranslation('enquiries');
  const router = useRouter();

  const [emitter] = useAnalyticsEmitter();

  return (
    <div>
      <div className="relative flex aspect-[2/1] w-full flex-col items-center justify-center">
        <Image
          alt="Enquiry sent"
          size={{
            sm: { span: 3, ratio: '2/1' },
            md: { span: 4, ratio: '2/1' },
            lg: { span: 12, ratio: '2/1' },
          }}
          src="https://images.avantarte.org/media/2zK9ati4bKfKE2zZQXrDCzTbrIk"
        />
      </div>

      <div className="x-50 absolute right-6 top-6 flex items-center justify-center">
        <Button
          hideLabel
          icon="ic_close"
          label="Close"
          onClick={() => closeFlow()}
          size="sm"
          variant="secondary"
        />
      </div>

      <div className="p-6">
        <div className="mx-auto flex w-full max-w-md flex-col items-center text-center">
          <p className="text-md font-bold">
            {t('drawers.successScreen.title')}
          </p>
          <p className="mb-6 mt-3 text-neutral-4">
            {t('drawers.successScreen.description', {
              title: productTitle,
            })}
          </p>
        </div>
        <Button
          fullWidth
          label={t('drawers.successScreen.buttonText')}
          onClick={() => {
            emitter('discover', 'clicked');
            router.push(pathFor({ page: 'WORKS_INDEX' }));
            closeFlow();
          }}
          variant="primary"
        />
      </div>
    </div>
  );
};
